import React from "react";
import { useNavigate } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { useLang } from "@/i18n";

export default function HelpButton() {
  const { t } = useLang();
  const nav = useNavigate();
  return (
    <button onClick={() => nav("/support")} data-testid="help-button"
      className="fixed bottom-5 right-5 z-50 bt-gradient text-white rounded-full shadow-lg shadow-primary/30 flex items-center gap-2 pl-4 pr-5 py-3 font-bold hover:scale-105 transition-transform">
      <LifeBuoy size={20} /> <span className="hidden sm:inline">{t("help_bubble")}</span>
    </button>
  );
}
